import "../.././styles/Constitution.css";

function ArticleTwo(){
    return(
        <>
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE II: DEFINITIONS AND INTERPRETATIONS</h3>
                    <h5>2.1 Definitions</h5>
                    <p>
                        In this Bylaw and all Board Resolutions, unless the context otherwise requires, the following
                        definitions will be used in the interpretation of the Constitution and By-Laws:
                    </p>
                    <ol type="a">
                        <li><p><p>
                            “Corporation” means the Philippine Canadian Centre of Manitoba, Inc.
                        </p></p></li>
                        <li><p>
                            “Governing Board” means elected and appointed directors of the corporation;
                        </p></li>
                        <li><p>
                            “Officer” means any officer listed and whose duties &amp; responsibilities listed in Article 5;
                        </p></li>
                        <li><p>
                            “Centre” means the Philippine Canadian Centre also known as Philippine Centre;
                        </p></li>
                        <li><p>
                            “Member” means a Member as defined in Article 2 of these By-Laws;
                        </p></li>
                        <li><p>
                            “Voting Member” means a member in good standing entitled to vote at general membership meetings;
                        </p></li>
                        <li><p>
                            “Observer” means a non-member of the corporation who may be allowed as guest during board meetings 
                            or annual general meeting but have no rights or privileges to ask questions or participate in any 
                            discussions;
                        </p></li>
                        <li><p>
                            “Special Meeting” means the special general meeting described in Article 3 of these By-Laws;
                        </p></li>
                        <li><p>
                            “Special Resolution” means a resolution passed at the Annual General Meeting of the general 
                            membership of the corporation; and
                        </p></li>
                        <li><p>
                            “Persons” includes individuals, firms, corporations, partnerships, societies and unincorporated 
                            organizations.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>2.2 Principles</h5>
                    <p>
                        The Philippine Canadian Centre of Manitoba, Inc. a duly registered corporation whose
                        members are comprised of Canadian citizens or permanent residents of Canada with
                        ancestral origin from the Philippines that has been founded on and will be guided in its
                        policy formation by the following principles:
                    </p>
                    <ol type="a">
                        <li><p>
                            A belief in a balance between fiscal accountability, progressive social policy, and individual rights 
                            &amp; responsibilities;
                        </p></li>
                        <li><p>
                            The goal of building a coalition of people who share these beliefs and who reflect the
                            regional, cultural and socio-economic diversity of the Philippines as country of origin;
                        </p></li>
                        <li><p>
                            The goal of developing a coalition that embrace our differences and respecting our
                            traditions yet honouring a concept of unison as the greater sum of strong parts;
                        </p></li>
                        <li><p>
                            The Philippine Canadian Centre of Manitoba Inc will operate in manner accountable and
                            responsive to its members; and
                        </p></li>
                        <li><p>
                            A belief in loyalty to united Filipino community governed in accordance with this
                            constitution &amp; by-laws, a democratic process and rule of law.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>2.3 Objectives</h5>
                    <p>
                        The objectives of the Corporation are:
                    </p>
                    <ol type="a">
                        <li><p>
                            to administer, manage, and operate the centre;
                        </p></li>
                        <li><p>
                            to develop, provide, promote and sponsor programs and services which are of benefit
                            and interest to members of the corporation;
                        </p></li>
                        <li><p>
                            to promote the development, maintenance and growth of Philippine Cultural Heritage
                            in Manitoba;
                        </p></li>
                        <li><p>
                            to collaborate &amp; foster unity, cooperation and interaction among the Filipino-Canadian
                            organizations in Manitoba; and
                        </p></li>
                        <li><p>
                            to promote intercultural relationships and activities between the Filipino community
                            and the various cultural communities in Manitoba.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>2.4 Headings</h5>
                    <p>
                        The caption or section numbers in the By-Laws are for ease of reference only and do not
                        define the scope or intent of the By-Laws or any particular provision.
                    </p>
                </div>
            </div>
        </>
    );
}

export default ArticleTwo;